import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container, Alert } from "reactstrap";

const RevenueValueRating = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          {/* Header Banner */}
          <div className="bg-gradient-primary p-4 text-white">
            <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
              VIDEO GUIDE
            </span>
            <h2 className="text-white mb-0 mt-1 font-weight-700">
              Athlete Page List
            </h2>
            <p className="text-white-50 mb-0 mt-2 font-weight-500" style={{ fontSize: "0.95rem" }}>
              Learn how to navigate and manage your athlete page list and ratings.
            </p>
          </div>

          <CardBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            {/* Embedded Player */}
            <div 
              className="embed-responsive embed-responsive-16by9 rounded-4 overflow-hidden shadow-sm bg-black mb-4"
              style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}
            >
              <iframe
                className="embed-responsive-item w-100"
                style={{ minHeight: isSmallScreen ? "250px" : "480px", border: "none" }}
                src="https://www.youtube.com/embed/EetM1EAQe50"
                title="Athlete Page List Guide"
                allowFullScreen
              ></iframe>
            </div>

            {/* Video description */}
            <Alert color="info" className="border-0 rounded-3 mb-0" style={{ backgroundColor: "#eef2ff", borderLeft: "4px solid #5e72e4" }}>
              <div className="d-flex align-items-center">
                <i className="fas fa-info-circle text-primary mr-3" style={{ fontSize: "20px" }}></i>
                <div>
                  <h5 className="alert-heading font-weight-700 text-primary mb-1">Login / Flow Overview</h5>
                  <p className="mb-0 text-muted" style={{ fontSize: "0.875rem" }}>
                    This walkthrough details the login flow and explains how athletes can track and optimize their page listings.
                  </p>
                </div>
              </div>
            </Alert>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default RevenueValueRating;
